import { render, staticRenderFns } from "./server.vue?vue&type=template&id=f0a7dd42&scoped=true&"
import script from "./server.vue?vue&type=script&lang=js&"
export * from "./server.vue?vue&type=script&lang=js&"
import style0 from "./server.vue?vue&type=style&index=0&id=f0a7dd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a7dd42",
  null
  
)

export default component.exports